import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosResponse, ResponseType } from 'axios';
import { API } from 'network/api';

export type UpdateApdMutationPayload = {
  taskAssignment: {
    id: string;
  };
  participants: {
    id: string;
    actualPlantingDate: string;
  }[];
};

const useUpdateApdMutation = (
  options?: UseMutationOptions<
    AxiosResponse<ResponseType>,
    Error,
    UpdateApdMutationPayload
  >,
) => {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    AxiosResponse<ResponseType>,
    Error,
    UpdateApdMutationPayload
  >({
    mutationFn: (payload: UpdateApdMutationPayload) =>
      API.post('/tasklog', payload),
    ...options,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        predicate(query) {
          // Invalidate queries related to season by ID
          return query.queryKey[0] === 'season-by-id';
        },
      });
      options?.onSuccess?.(...args);
    },
  });

  return mutation;
};

export default useUpdateApdMutation;
